import React, { createContext, ReactNode } from 'react';

interface SiteSettingsContextProps {
	isBannerActive: boolean;
}

export const SiteSettingsContext = createContext<
	SiteSettingsContextProps | undefined
>(undefined);

export const SiteSettingsProvider: React.FC<{
	children: ReactNode;
	isBannerActive: boolean;
}> = ({ children, isBannerActive }) => {
	return (
		<SiteSettingsContext.Provider value={{ isBannerActive }}>
			{children}
		</SiteSettingsContext.Provider>
	);
};
